var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-card',[_c('b-spinner',{staticClass:"mt-1 mb-1",attrs:{"variant":"primary","label":"Spinning"}}),_c('b-card-text',[_c('h5',[_vm._v("데이터 수집중...")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }